import { Branch } from '../../shared/model/branch';
import { Equipment } from '../../shared/model/equipment';
import { Screening } from './screening';
import { Scheduling } from './scheduling';
import { Monitoring } from './monitoring';
import { Dispatch } from './dispatch';
import { Configuration } from './configuration';
import AttendingInfo from './attending-info';
import { Validation } from './validation';
import { AttendingScore } from './attending-score';

export class Attending {

  constructor(public id?,
              public currentStep?,
              public jiraTicket?,
              public serviceOrder?,
              public vehiclePlate?,
              public branch?: Branch,
              public equipment?: Equipment,
              public screening?: Screening,
              public dispatch?: Dispatch,
              public monitoring?: Monitoring,
              public scheduling?: Scheduling,
              public configuration?: Configuration,
              public finished?: boolean,
              public firstStep?,
              public diagnosisGeneralResults?: Array<any>,
              public orderedSteps?: Array<any>,
              public attendingEquipmentInfo?: any,
              public accessoryMovementLogs?: Array<any>,
              public attendingInfo?: AttendingInfo,
              public profile?,
              public validation?: Validation,
              public invoiceNumber?,
              public type?: string,
              public technicianScore?: AttendingScore,
              public monitoringUserScore?: AttendingScore) {
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/model/attending.ts